export default {
  colPhoneCost: {
    id: 'us_telco_comparators_landing_page_comparison_row_col_phone_cost',
    defaultMessage: 'Cost of iPhone 15 Pro',
  },
  colPlanCost: {
    id: 'us_telco_comparators_landing_page_comparison_row_col_plan_cost',
    defaultMessage: 'Cost of plan',
  },
  savingsLabel: {
    id: 'us_telco_comparators_landing_page_comparison_row_savings_label',
    defaultMessage: 'Saves you {amount}',
  },
}
